import { c as _c } from "react/compiler-runtime";
import React from 'react';
import usePDPBasicDetails from 'components/consumer/PDP/state/context/usePDPBasicDetails';
import useProductLayoutWidgets from 'data-hooks/useProductLayoutWidgets';
import { PDP_DECIDELATER_TAB_ID } from 'commons/constants';
import usePDPPrice from 'data-hooks/usePDPPrice';
import usePDPClearanceData from 'data-hooks/useClearanceData/usePDPClearanceData';
import PDPKeySellingPointsUI from './PDPKeySellingPointsUI';
import usePdpSelectedCustomizerTab from '../state/pdpSelectedCustomizerTab/usePdpSelectedCustomizerTab';
const PDPKeySellingPointsV1 = () => {
  const $ = _c(12);
  const {
    loading,
    error,
    data
  } = usePDPBasicDetails();
  const {
    loading: layoutWidgetLoading,
    data: layoutWidgetData
  } = useProductLayoutWidgets();
  const {
    data: t0
  } = usePDPClearanceData();
  const {
    isClearance
  } = t0;
  const pdpSelectedCustomizerTab = usePdpSelectedCustomizerTab();
  const {
    data: priceData
  } = usePDPPrice();
  const {
    isClearance: priceClearance,
    clearanceStockPerSKU
  } = priceData || {};
  const isDecideLaterTab = pdpSelectedCustomizerTab === PDP_DECIDELATER_TAB_ID;
  if (!data && loading || !layoutWidgetData && layoutWidgetLoading) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <PDPKeySellingPointsUI loading={true} />;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  if (error) {
    return "Something went wrong, please try again";
  }
  let widgets;
  if ($[1] !== layoutWidgetData?.layout_widgets) {
    widgets = {};
    if (layoutWidgetData?.layout_widgets && layoutWidgetData?.layout_widgets.length) {
      layoutWidgetData?.layout_widgets.forEach(l => {
        widgets[l.widget_identifier] = l.fields;
      });
    }
    $[1] = layoutWidgetData?.layout_widgets;
    $[2] = widgets;
  } else {
    widgets = $[2];
  }
  if (priceClearance && !clearanceStockPerSKU?.flashSale && !isDecideLaterTab) {
    return null;
  }
  const t1 = data?.type;
  const t2 = data?.efg_flag;
  const t3 = data?.difficulty;
  const t4 = data?.is_external;
  const t5 = data?.category_ids;
  const t6 = data?.custom_properties?.campaign;
  let t7;
  if ($[3] !== isClearance || $[4] !== t1 || $[5] !== t2 || $[6] !== t3 || $[7] !== t4 || $[8] !== t5 || $[9] !== t6 || $[10] !== widgets.product_description) {
    t7 = <PDPKeySellingPointsUI type={t1} efg_flag={t2} difficulty={t3} is_external={t4} category_ids={t5} fields={widgets.product_description} showClearanceWarning={isClearance} campaign={t6} />;
    $[3] = isClearance;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
    $[10] = widgets.product_description;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  return t7;
};
export default PDPKeySellingPointsV1;